<div class="parent-modal">
  <!-- Global file input for document upload -->
  <input 
    type="file" 
    id="global-document-file-input"
    accept=".doc,.docx,.pdf,.txt"
    style="display: none; position: absolute;"
    (change)="onFileSelected($event)"
  />
  
  <div class="modal-title-header">
    <div class="mwc-icon-highlight-primary-md">
      <span mwc-icon [mwcIconfont]="'edit-04'" style="font-size: 18px"></span>
    </div>
    <div>
      <div class="mwc-text-xl-medium mwc-color-gray-900">Start Building Content for all your web pages</div>
    </div>
  </div>
  <div class="template-container">
    <!-- Left side navigation mimicking new-template-selector -->
    <div class="template-nav">
      <ul class="template-menu">
        <li class="menu-item mwc-text-sm-medium mwc-color-gray-700" [class.selected]="selectedIndex === 0" (click)="tabSelectChange(['click', tabs[0]])">
          <a>
            <span mwc-icon [mwcIconfont]="tabs[0].iconName"></span>{{tabs[0].name}}
          </a>
        </li>
        <li class="menu-item mwc-text-sm-medium mwc-color-gray-700" [class.selected]="selectedIndex === 1" (click)="tabSelectChange(['click', tabs[1]])">
          <a>
            <span mwc-icon [mwcIconfont]="tabs[1].iconName"></span>{{tabs[1].name}}
          </a>
        </li>
        <li class="menu-item mwc-text-sm-medium mwc-color-gray-700" [class.selected]="selectedIndex === 2" (click)="tabSelectChange(['click', tabs[2]])">
          <a>
            <span mwc-icon [mwcIconfont]="tabs[2].iconName"></span>{{tabs[2].name}}
          </a>
        </li>
        <li *ngIf="showContentInstructions" class="menu-item mwc-text-sm-medium mwc-color-gray-700" [class.selected]="selectedIndex === contentInstructionsTab.index" (click)="tabSelectChange(['click', contentInstructionsTab])">
          <a>
            <span mwc-icon [mwcIconfont]="contentInstructionsTab.iconName"></span>{{contentInstructionsTab.name}}
          </a>
        </li>
        <li class="menu-item mwc-text-sm-medium mwc-color-gray-700" [class.selected]="selectedIndex === 3" (click)="tabSelectChange(['click', tabs[3]])">
          <a>
            <span mwc-icon [mwcIconfont]="tabs[3].iconName"></span>{{tabs[3].name}}
          </a>
        </li>
        <li class="menu-item mwc-text-sm-medium mwc-color-gray-700" [class.selected]="selectedIndex === 4" (click)="tabSelectChange(['click', tabs[4]])">
          <a>
            <span mwc-icon [mwcIconfont]="tabs[4].iconName"></span>{{tabs[4].name}}
          </a>
        </li>
        <li class="menu-item mwc-text-sm-medium mwc-color-gray-700" [class.selected]="selectedIndex === 5" (click)="tabSelectChange(['click', tabs[5]])">
          <a>
            <span mwc-icon [mwcIconfont]="tabs[5].iconName"></span>{{tabs[5].name}}
          </a>
        </li>
        
      </ul>
    </div>

    <!-- Right side content area -->
    <div class="template-sec">
      <form [formGroup]="workflowForm">
        <!-- Analysis Loading Screen -->
        <div *ngIf="isAnalyzing">
          <div class="mwc-text-xl-medium mwc-color-gray-900">{{ selectedIndex === 0 ? 'Analyze Website' : 'Analyze Pages' }}</div>
          <div class="analyzing-screen">
          <div class="analyzing-image">
            <img src="assets/images/ai-loader.gif" alt="Analyzing" style="height: 50px; width: 50px;">
          </div>
          <div class="mwc-text-md-medium mwc-color-gray-700">{{ selectedIndex === 0 ? 'Analyzing the URL' : 'Analyzing the documents' }}</div>
          <div class="mwc-text-sm-regular mwc-color-gray-500">This may take some time to analyze <p>and generate the data for you.</p></div>
          </div>
        </div>
        
        <div [ngSwitch]="selectedIndex" class="tab-content" *ngIf="!isAnalyzing">
          <!-- Analyze Website -->
          <div *ngSwitchCase="0">
            <div class="mwc-text-lg-medium mwc-color-gray-700" style="margin-bottom: 20px;">Analyze Website</div>
            <div *ngIf="isParentUrlVisible">
              <mwc-form-item class="form-item-sec">
                <mwc-form-label [mwcSpan]="24" class="mwc-text-sm-medium mwc-color-gray-900">Enter Website Domain <span mwc-icon style="font-size: 16px;color:#475467;margin-left: 5px;" mwcIconfont="info-circle" class="help-circle" [mwcTooltipTitle]="'We will scan 50 pages from the given domain'" mwcTooltipPlacement="top" mwc-button mwc-tooltip></span></mwc-form-label>
                <mwc-form-control [mwcSpan]="24">
                  <input mwc-input formControlName="websiteUrl" placeholder="https://example.com" class="mwc-text-sm-regular" mwcSize="small" (input)="parentUrlChange()"/>
                </mwc-form-control>
              </mwc-form-item>
            </div>
            <!-- <div style="position: relative;" *ngIf="isParentUrlVisible && isIndividualUrlVisible">
              <mwc-divider style="margin: 36px 0;"></mwc-divider>
              <button mwc-button mwcType="default" mwcSize="small" class="or-btn">OR</button>
            </div> -->
            <div *ngIf="isIndividualUrlVisible">
              <mwc-form-item class="upload-urls-form-item upload-urls-textarea-item">
                <mwc-form-label [mwcSpan]="24" class="upload-urls-label">
                  Enter Individual URLs <span class="upload-urls-limit">(Max limit: 500)</span>
                </mwc-form-label>
                <mwc-form-control [mwcSpan]="24" [mwcErrorTip]="individualUrlsError">
                  <textarea mwc-input formControlName="individualUrls" placeholder="Enter URLs, one URL per row" class="upload-urls-textarea" rows="5" (input)="individualUrlsChange()"></textarea>
                </mwc-form-control>
                <ng-template #individualUrlsError let-control>
                  <ng-container *ngIf="control?.dirty || control?.touched">
                    <div *ngIf="control?.hasError('invalidUrl')">
                      One or more URLs are invalid. Please enter valid URLs starting with http:// or https://
                    </div>
                    <div *ngIf="control?.hasError('multipleDomainsNotAllowed')">
                      All URLs must belong to the same domain.
                    </div>
                    <div *ngIf="control?.hasError('maxUrlsExceeded')">
                      You can enter a maximum of 300 URLs
                    </div>
                  </ng-container>
                </ng-template>  
              </mwc-form-item>
            </div>
            <ng-container *ngIf="isParentUrlVisible && !isIndividualUrlVisible">
              <div class="mwc-text-sm-medium my-2">Want to<a mwc-button mwcType="link-color" class="mwc-color-primary-700 ms-1" style="text-decoration: underline;" (click)="individualUrlsChange()"><span class="mwc-color-primary-700 mwc-text-sm-regular">enter individual URLs</span></a> instead?</div>
            </ng-container>
            <ng-container *ngIf="isIndividualUrlVisible && !isParentUrlVisible">
              <div class="mwc-text-sm-medium my-2">Want to<a mwc-button mwcType="link-color" class="mwc-color-primary-700 ms-1" style="text-decoration: underline;" (click)="parentUrlChange()"><span class="mwc-color-primary-700 mwc-text-sm-regular">enter website domain</span></a> instead?</div>
            </ng-container>
          </div>
          
          <!-- Add Keywords -->
          <div *ngSwitchCase="1">
            <div class="mwc-text-lg-medium mwc-color-gray-700" style="margin-bottom: 20px;">Add or Generate Keywords</div>
            <div class="mwc-text-sm-medium mwc-color-gray-900" style="margin-bottom: 8px;">
              What are the keywords you would like to target? Add the keywords that you want to assign to individual pages
            </div>

            <!-- Keywords input section -->
            <div class="selected-keywords">
              <mwc-tag *ngFor="let selectedKeyword of selectedKeywords; let i = index" [mwcMode]="'closeable'"
                       (mwcOnClose)="removeKeyword(selectedKeyword)" class="mwc-input-tag-list mwc-text-xs-medium" 
                       mwcTooltip [mwcTooltipTitle]="selectedKeyword">
                <span class="keyword-text">{{ sliceKeyword(selectedKeyword) }}</span>
              </mwc-tag>
              <span *ngIf="!keywordInputVisible && !(selectedKeywords.length >= maxKeywordsAllowed)" 
                    class="editable-tag mwc-text-sm-regular mwc-color-gray-400"
                    mwcNoAnimation (click)="showKeywordInput()" 
                    style="width:150px;display:flex; align-items: center; height: 22px;">{{ selectedKeywords.length > 0 ? '+ More Keywords' : '+ Add Keyword' }}</span>
              <input #inputElement mwc-input mwcSize="small" *ngIf="keywordInputVisible" type="text"
                     [ngModelOptions]="{standalone: true}" [(ngModel)]="selectedKeywordInputValue"
                     (blur)="addKeywordToSelectedKeywords()" (keydown.enter)="addKeywordToSelectedKeywords()"
                     class="mwc-tag-input mwc-text-sm-regular"  />
            </div>
            
            <mwc-form-item class="form-item-sec mt-2">
              <mwc-form-label [mwcSpan]="24">Upload Keywords</mwc-form-label>
              <mwc-form-control [mwcSpan]="24">
                <div style="display: flex;flex-direction: column;" class="bulk-upload">
                  <ng-container>
                    <mwc-upload mwcType="drag" [mwcMultiple]="false" mwcAccept=".xlsx, .xls" (mwcChange)="handleChange($event)" [(mwcFileList)]="fileList" [mwcHint]="'XLSX, XLS'" [mwcIconRender]="renderTemplate" [mwcBeforeUpload]="beforeUpload">
                      <ng-template #renderTemplate>
                        <span mwc-icon style="font-size: 16px;" [mwcIconfont]="(fileList[0] && (fileList[0].percent >= 100 || fileList[0].status == 'done' )? 'check-circle':'file-04')"></span>
                      </ng-template>
                    </mwc-upload>
                  </ng-container>
                </div>
              </mwc-form-control>
            </mwc-form-item>
            <!-- <div class="generate-btn" style="margin-top: 0px; margin-bottom: 10px; z-index: 9; position: relative; display: flex; justify-content: space-between;">
              <button mwc-button mwcType="default-color" mwcSize="small" class="discover-absolute-btn" 
                      [disabled]="(selectedKeywords.length >= maxKeywordsAllowed) || !isKeywordDiscoveryEnabled"
                      (click)="discoverKeywords()">
                <span mwc-icon [mwcIconfont]="'stars-02'" style="font-size: 16px;"></span>
                Discover Keywords
              </button>
            </div> -->
            
            <!--<div class="keywords-count-wrapper" style="display: flex; justify-content: flex-end; align-items: center; margin-top: 10px;">
              <div class="mwc-text-xs-regular">{{selectedKeywords.length}}/{{maxKeywordsAllowed}}</div>
            </div>-->
          </div>
          
          <!-- Page Configuration -->
          <div *ngSwitchCase="2">
            <div style="display: flex; justify-content: space-between;">
            <div class="mwc-text-lg-medium mwc-color-gray-700">Page Configuration</div>
            <div>
              <button mwc-button mwcType="default" mwcSize="small">
                  Manage Templates
                  <span mwc-icon mwcIconfont="link-external-02"></span>
                </button>
            </div>
            </div>
            
            <div class="page-config-table-container mt-4">
              <mwc-table [mwcData]="pageData" [mwcFrontPagination]="false" [mwcShowPagination]="false" [mwcLoadingIndicator]="tableSpinTpl">
                <thead>
                  <tr>
                    <th [mwcChecked]="checked" [mwcIndeterminate]="indeterminate" (mwcCheckedChange)="onAllChecked($event)" class="mwc-text-sm-medium" style="width: 5%;"></th>
                    <th class="mwc-text-sm-medium" style="width: 25%;">Page Found</th>
                    <th class="mwc-text-sm-medium" style="width: 40%;">Assigned Keywords</th>
                    <th class="mwc-text-sm-medium" style="width: 20%;">Template</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Dynamically generate rows for each page -->
                  <tr *ngFor="let page of pageData; let i = index">
                    <td [mwcChecked]="setOfCheckedId.has(page.id)" (mwcCheckedChange)="onItemChecked(page.id, $event)"></td>
                    <td>
                      <div class="mwc-color-gray-600 mwc-text-sm-medium">{{ page.title }}</div>
                      <div class="mwc-text-xs-regular mwc-color-gray-600">{{ page.url }}</div>
                    </td>
                    <td>
                      <div class="keyword-tags">
                        <!-- Existing tags -->
                        <ng-container *ngFor="let keyword of page.keywords.slice(0,2); let kidx = index">
                          <mwc-tag class="tag-keyword" style="width: 75px;" mwcMode="closeable" mwc-tooltip [mwcTooltipTitle]="keyword" (mwcOnClose)="page.keywords.splice(kidx, 1)">
                            <span class="keyword-text">{{ keyword }}</span>
                          </mwc-tag>
                        </ng-container>
                        <ng-container *ngIf="page.keywords.length > 2">
                          <mwc-tag class="tag-keyword" style="max-width: 40px;" mwcMode="default">
                            <span class="keyword-text">+{{ page.keywords.length - 2 }}</span>
                          </mwc-tag>
                        </ng-container>
                        
                        <!-- Add new tag button with dropdown menu -->
                        <div class="keyword-plus-button">
                          <a mwc-dropdown 
                             [mwcDropdownMenu]="keywordMenu" 
                             mwcTrigger="click" 
                             mwcPlacement="bottomLeft">
                            <button mwc-button mwcType="link-color" mwcSize="small" (click)="addKeywordToPage(i)">
                              <span mwc-icon mwcIconfont="plus" style="font-size: 16px; margin-left: -12px;"></span>
                            </button>
                          </a>
                        </div>
                        <!-- Keyword selection dropdown menu -->
                        <mwc-dropdown-menu #keywordMenu="mwcDropdownMenu">
                          <ul mwc-menu>
                            <li style="padding: 2px 6px;">
                              <div class="keyword-dropdown-content" (click)="$event.stopPropagation()">
                                <!-- <div class="mwc-text-sm-medium mwc-color-gray-700 pb-2">Select Keywords</div> -->
                                <div class="keyword-options">
                                  <div *ngFor="let option of listOfOption" 
                                       class="keyword-option mwc-text-sm-regular" 
                                       [class.selected]="isKeywordSelected(option.label)"
                                       (click)="toggleKeywordSelection(option.label); $event.stopPropagation();">
                                    <span class="option-checkbox">
                                      <span *ngIf="isKeywordSelected(option.label)" mwc-icon mwcIconfont="check" class="check-icon"></span>
                                    </span>
                                    <span class="mwc-text-sm-medium mwc-color-gray-900">{{ option.label }}</span>
                                  </div>
                                </div>
                                <div class="keyword-actions">
                                  <button mwc-button mwcType="default" mwcSize="small" (click)="cancelKeywordSelection(); $event.stopPropagation();">
                                    Cancel
                                  </button>
                                  <button mwc-button mwcType="primary" mwcSize="small" 
                                          (click)="confirmKeywordSelection(); $event.stopPropagation();" 
                                          [disabled]="selectedKeywords.length === 0">
                                    Add Keywords
                                  </button>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </mwc-dropdown-menu>
                      </div>
                    </td>
                    <td>
                      <mwc-select mwcSize="small" class="mwc-text-sm-regular template-select" [(ngModel)]="page.template" [ngModelOptions]="{standalone: true}" [mwcDropdownClassName]="'mwc-xs-select-dropdown'" class="select-layout mwc-xs-select mwc-xxs-select mwc-text-sm-medium" style="width: 150px !important;" [mwcOptionHeightPx]="36">
                        <mwc-option *ngFor="let option of templateOptions" [mwcLabel]="option.label" [mwcValue]="option.value">
                          {{ option.label }}
                        </mwc-option>
                      </mwc-select>
                    </td>
                  </tr>
                </tbody>
              </mwc-table>
            </div>
          </div>
          
          <!-- Brand Voice -->
          <div *ngSwitchCase="3">
            <ng-container>
              <ng-container *ngIf="isNoCreateBrandVoice">
                <div class="empty-screen-branch-voice">
                  <div><img src="../../assets/images/Illustration-no-brand-voice.svg" /></div>
                  <div>
                    <div class="mwc-text-md-medium mwc-color-gray-700 pb-2">No Brand Voice Found!</div>
                    <div class="mwc-text-sm-regular mwc-color-gray-600">Add a brand voice using the button below to start creating intelligent content</div>
                  </div>
                  <button mwc-button mwcType="default-color" mwcSize="small" (click)="openRedirectToMPC('brandVoice')" class="mwc-text-sm-medium"><span mwc-icon mwcIconfont="plus" style="font-size: 18px;"></span>Create Brand Voice</button>
                </div>
              </ng-container>
              <ng-container *ngIf="!isNoCreateBrandVoice">
                <div class="d-flex align-items-center mb-3 justify-content-between">
                  <div class="mwc-text-lg-medium">{{'Brand Voice'}}</div>
                  <div class="d-flex align-items-center gap-2">
                    <ng-container *ngIf="!isShowDetailsBV">
                      <button mwc-button mwcType="link-color" mwcSize="small" (click)="reloadList('brandVoice')" style="margin-right: 8px; color: #004EEB;"><span mwc-icon mwcIconfont="refresh-ccw-01" style="font-size: 16px; color: #004EEB;"></span> Refresh </button>
                      <button mwc-button mwcType="default-color" mwcSize="small" (click)="openRedirectToMPC('brandVoice')"><span mwc-icon mwcIconfont="plus" style="font-size: 18px;"></span> Create New </button>
                    </ng-container>
                    <ng-container *ngIf="isShowDetailsBV">
                      <button mwc-button mwcType="default-color" mwcSize="small" (click)="changeBV()"><span mwc-icon mwcIconfont="arrow-left" style="font-size: 18px;"></span> Change Brand Voice </button>
                    </ng-container>
                  </div>
                </div>
                <ng-container *ngIf="!isShowDetailsBV">
                  <div style="width: 100%;margin: 0 auto 16px 0;">
                    <mwc-input-group [mwcPrefix]="prefixIconSearch">
                      <input mwc-input [formControl]="bvSearchField" type="text" class="mwc-text-sm-regular" [(ngModel)]="searchTxt" (keyup)="triggerSearchBV()" placeholder="Search from all existing brand voices by name" mwcSize="small" />
                    </mwc-input-group>
                    <ng-template #prefixIconSearch>
                      <span mwc-icon mwcIconfont="search-lg" style="font-size: 18px; color: #667085;"></span>
                    </ng-template>
                  </div>
                  <ng-container *ngIf="!FoundSerchBV">
                    <div class="empty-screen-branch-voice">
                      <div><img src="../../assets/images/Illustration-no-brand-voice.svg" /></div>
                      <div>
                        <div class="mwc-text-md-medium mwc-color-gray-700 pb-2">No Brand Voice Found!</div>
                      </div>
                    </div>
                  </ng-container>
                  <div class="grid-sec" *ngIf="FoundSerchBV">
                    <mwc-card *ngFor="let bvCard of filteredBrandVoiceList; let i = index" class="grid-card" [mwcBodyStyle]="{'padding':'16px'}" style="cursor: pointer;" [ngClass]="(bvCard.isDefault || bvCard.isSelectedBV) ? 'select-grid':''">
                      <div class="get-started-overlay">
                        <button mwc-button mwcType="primary" mwcSize="small" style="width:135px" class="mwc-text-sm-medium" (click)="SelectedBV(bvCard.value)">
                          <span class="mwc-text-sm-medium">{{(bvCard.isDefault || bvCard.isSelectedBV) ? 'Selected' : 'Select'}}</span>
                        </button>
                        <a mwc-button mwcType="link-color" mwcSize="small" class="mwc-text-sm-medium" (click)="selectBV(bvCard.value)">
                          <span mwc-icon mwcIconfont="eye" style="font-size: 16px;"></span>
                          <span class="mwc-text-sm-medium">View Details</span>
                        </a>
                      </div>
                      <div>
                        <div class="d-flex align-items-center justify-content-between mb-1">
                          <div mwc-typography mwcEllipsis class="mwc-text-md-medium m-0">{{bvCard.label}}</div>
                        </div>
                        <div class="mwc-text-xs-regular"><span class="mwc-text-xs-regular mwc-color-gray-500">Created: </span><span class="mwc-text-xs-medium mwc-color-gray-700">{{getDaysDifference(bvCard.createdOn)}}</span></div>
                        <div class="mwc-text-xs-regular mt-3 mb-1"><span class="mwc-text-xs-regular mwc-color-gray-500">Tone: </span><span class="mwc-text-xs-medium mwc-color-gray-700">{{bvCard.tone}}</span></div>
                        <div class="mwc-text-xs-regular"><span class="mwc-text-xs-regular mwc-color-gray-500">Created By: </span><span class="mwc-text-xs-medium mwc-color-gray-700">{{bvCard.createdBy}}</span></div>
                      </div>
                    </mwc-card>
                  </div>
                </ng-container>
                <ng-container *ngIf="isShowDetailsBV">
                  <div style="width: 100%;margin-top: 16px; padding-left: 16px; padding-right: 16px; padding-top: 12px; padding-bottom: 12px; background: white; border-radius: 12px; border: 1px #D0D5DD solid;">
                    <div style="display: flex;align-items: flex-start;gap: 8px;justify-content: space-between;border-bottom: 1px solid #EAECF0;padding-bottom: 12px;">
                      <div class="d-flex align-items-center gap-2">
                        <div style="width: 40px; height: 40px; padding: 10px; background: #EAECF0; border-radius: 20px; justify-content: center; align-items: center; display: flex">
                          <div style="display: flex; color: #667085">
                            <span mwc-icon mwcIconfont="clipboard-report"></span>
                          </div>
                        </div>
                        <div>
                          <div class="mwc-text-md-medium mwc-color-gray-700">{{brandVoiceDetails?.label}}</div>
                          <div style="display: flex;align-items: center;gap:8px">
                            <div><span class="mwc-text-xs-regular mwc-color-gray-500">Tone: </span><span class="mwc-text-xs-medium mwc-color-gray-700">{{brandVoiceDetails?.tone}}</span></div>
                            <div><span class="mwc-text-xs-regular mwc-color-gray-500">Created By: </span><span class="mwc-text-xs-medium mwc-color-gray-700">{{brandVoiceDetails?.createdBy}}</span></div>
                            <div><span class="mwc-text-xs-regular mwc-color-gray-500">Created: </span><span class="mwc-text-xs-medium mwc-color-gray-700">{{getDaysDifference(brandVoiceDetails?.createdOn)}}</span></div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <label mwc-checkbox class="mt-1" [mwcSize]="'small'" [(mwcChecked)]="isDefaultBVAvailable"><span class="mwc-text-xs-medium">Save Selection for Later</span></label>
                      </div>
                    </div>
                    <div style="margin: 12px 0 0;">
                      <div class="mwc-text-sm-regular mwc-color-gray-500" [innerHTML]="brandVoiceDetails.brandVoiceDocument" style="white-space: pre-wrap;"></div>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
            </ng-container>
          </div>
          
          <!-- Target Audience -->
          <div *ngSwitchCase="4">
              <ng-container *ngIf="isNoTargetAudience">
                <div class="empty-screen-branch-voice">
                  <div><img src="../../assets/images/Illustration-no-target-audience.svg" /></div>
                  <div>
                    <div class="mwc-text-md-medium mwc-color-gray-700 pb-2">No target audience found</div>
                    <div class="mwc-text-sm-regular mwc-color-gray-600">Add a target audience using the button below to start creating intelligent content</div>
                  </div>
                  <button mwc-button mwcType="default-color" mwcSize="small" (click)="openRedirectToMPC('targetAudience')" class="mwc-text-sm-medium"><span mwc-icon mwcIconfont="plus" style="font-size: 18px;"></span>Create Target Audience</button>
                </div>
              </ng-container>
              <ng-container *ngIf="!isNoTargetAudience">
                <div class="d-flex align-items-center mb-3 justify-content-between">
                  <div class="mwc-text-lg-medium">{{'Target Audience'}}</div>
                  <div class="d-flex align-items-center gap-2">
                    <ng-container *ngIf="!isShowDetailsTA">
                      <button mwc-button mwcType="link" mwcSize="small" (click)="reloadList('targetAudience')" style="margin-right: 8px; color: #004EEB;"><span mwc-icon mwcIconfont="refresh-ccw-01" style="font-size: 16px; color: #004EEB;"></span> Refresh </button>
                      <button mwc-button mwcType="default-color" mwcSize="small" (click)="openRedirectToMPC('targetAudience')"><span mwc-icon mwcIconfont="plus" style="font-size: 18px;"></span> Create New </button>
                    </ng-container>
                    <ng-container *ngIf="isShowDetailsTA">
                      <button mwc-button mwcType="default" mwcSize="small" (click)="viewAllTA()"><span mwc-icon mwcIconfont="arrow-left" style="font-size: 18px;"></span>View all </button>
                    </ng-container>
                  </div>
                </div>
                <ng-container *ngIf="!isShowDetailsTA">
                  <div style="width: 100%;margin: 0 auto 16px 0;">
                    <mwc-input-group [mwcPrefix]="prefixIconSearch">
                      <input mwc-input [formControl]="tvSearchField" type="text" class="mwc-text-sm-regular" [(ngModel)]="searchTxt" (keyup)="triggerSearchTA()" placeholder="Search from all existing personas by name" mwcSize="small" />
                    </mwc-input-group>
                    <ng-template #prefixIconSearch>
                      <span mwc-icon mwcIconfont="search-lg" style="font-size: 18px; color: #667085;"></span>
                    </ng-template>
                  </div>
                  <ng-container *ngIf="!FoundSearchTA">
                    <div class="empty-screen-branch-voice">
                      <div><img src="../../assets/images/Illustration-no-target-audience.svg" /></div>
                      <div>
                        <div class="mwc-text-md-medium mwc-color-gray-700 pb-2">No Target Audience Found!</div>
                      </div>
                    </div>
                  </ng-container>
                  <div class="grid-sec" *ngIf="FoundSearchTA">
                    <mwc-card *ngFor="let taCard of filteredTargetAudienceList; let i = index" class="grid-card" [mwcBodyStyle]="{'padding':'16px'}" style="cursor: pointer;" [ngClass]="(taCard.isDefault || taCard.isSelectedTA) ? 'select-grid':''">
                      <div class="get-started-overlay">
                        <button mwc-button mwcType="primary" mwcSize="small" style="width:135px" class="mwc-text-sm-medium" (click)="SelectedTA(taCard.title)">
                          <span class="mwc-text-sm-medium">{{ taCard.isDefault || taCard.isSelectedTA ? 'Selected': 'Select' }}</span>
                        </button>
                        <a mwc-button mwcType="link-color" mwcSize="small" class="mwc-text-sm-medium" (click)="selectTA(taCard.title)">
                          <span mwc-icon mwcIconfont="eye" style="font-size: 16px;"></span>
                          <span class="mwc-text-sm-medium">View Details</span>
                        </a>
                      </div>
                      <div>
                        <div class="d-flex align-items-center justify-content-between">
                          <div mwc-typography mwcEllipsis class="mwc-text-md-medium m-0">{{taCard.title}}</div>
                        </div>
                        <div class="mb-2"><span class="mwc-text-xs-regular mwc-color-gray-500">Created: </span><span class="mwc-text-xs-medium mwc-color-gray-700">{{getDaysDifference(taCard.createdDate)}}</span></div>
                        <div style="line-height: normal;">
                          <span class="mwc-text-xs-regular mwc-color-gray-500">Gender: </span>
                          <ng-container *ngFor="let gender of taCard.thingTargetAudience.thingJson.gender;let last = last; let first = first;">
                            <span class="mwc-text-xs-medium mwc-color-gray-700">{{gender}}</span> <span class="me-1" *ngIf="!last">{{!last ? ',' : '&'}}</span>
                          </ng-container>
                        </div>
                        <div style="line-height: normal;">
                          <span class="mwc-text-xs-regular mwc-color-gray-500">Age group: </span>
                          <ng-container *ngFor="let age of taCard.thingTargetAudience.thingJson.ageGroup;let last = last;">
                            <span class="mwc-text-xs-medium mwc-color-gray-700">{{age}}</span>
                            <span class="me-1" *ngIf="!last">{{taCard.thingTargetAudience.thingJson.ageGroup.length - 1  ? ',' : '&'}}</span>
                          </ng-container>
                        </div>
                      </div>
                    </mwc-card>
                  </div>
                </ng-container>
                <ng-container *ngIf="isShowDetailsTA">
                  <div style="width: 100%;margin-top: 16px; padding-left: 16px; padding-right: 16px; padding-top: 12px; padding-bottom: 12px; background: white; border-radius: 12px; border: 1px #D0D5DD solid;">
                    <div style="display: flex;align-items: center;gap: 8px;justify-content: space-between;">
                      <div class="d-flex align-items-center gap-2">
                        <div style="min-width: 40px; height: 40px; padding: 10px; background: #EAECF0; border-radius: 20px; justify-content: center; align-items: center; display: flex">
                          <div style="display: flex; color: #667085">
                            <span mwc-icon mwcIconfont="users-03"></span>
                          </div>
                        </div>
                        <div>
                          <div class="mwc-text-md-medium mwc-color-gray-700" mwc-typography mwcEllipsis style="margin: 0;width: 86%;">{{targetAudienceDetails?.title}}</div>
                          <div style="display: flex;align-items: center;gap:8px">
                            <div><span class="mwc-text-xs-regular mwc-color-gray-500">Created By: </span><span class="mwc-text-xs-medium mwc-color-gray-700">{{targetAudienceDetails?.authorName}}</span></div>
                            <div><span class="mwc-text-xs-regular mwc-color-gray-500">Created: </span><span class="mwc-text-xs-medium mwc-color-gray-700">{{getDaysDifference(targetAudienceDetails.createdDate)}}</span></div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <label mwc-checkbox class="mt-1" [mwcSize]="'small'" [(mwcChecked)]="isDefaultTAAvailable"><span class="mwc-text-xs-medium">Save Selection for Later</span></label>
                      </div>
                    </div>
                    <div style="margin-top: 12px;border-top: 1px solid #efefef;padding-top: 10px;">
                      <div mwc-row [mwcGutter]="[24,12]">
                        <div mwc-col [mwcSpan]="12">
                          <div class="mwc-text-sm-regular mwc-color-gray-500 mb-1"> Age Group: </div>
                          <ng-container>
                            <div class="view-layout">
                              <ng-container *ngFor="let age of targetAudienceDetails.thingTargetAudience.thingJson.ageGroup;let last = last; let first = first;">
                                <span class="mwc-text-sm-medium mwc-color-gray-700">{{age}}</span> <span *ngIf="!last" class="mx-1">|</span>
                              </ng-container>
                            </div>
                          </ng-container>
                        </div>
                        <div mwc-col [mwcSpan]="12">
                          <div class="mwc-text-sm-regular mwc-color-gray-500 mb-1">Family Status:</div>
                          <ng-container>
                            <div class="view-layout">
                              <div *ngFor="let status of targetAudienceDetails.thingTargetAudience.thingJson.relationshipStatus;let last = last; let first = first;">
                                <span class="mwc-text-sm-medium">{{status}}</span> <span *ngIf="!last" class="mx-1">|</span>
                              </div>
                            </div>
                          </ng-container>
                        </div>
                        <div mwc-col [mwcSpan]="12">
                          <div class="mwc-text-sm-regular mwc-color-gray-500 mb-1">Gender:</div>
                          <ng-container>
                            <div class="view-layout">
                              <div *ngFor="let gender of targetAudienceDetails.thingTargetAudience.thingJson.gender;let last = last; let first = first;">
                                <span class="mwc-text-sm-medium">{{gender}}</span> <span *ngIf="!last" class="mx-1">|</span>
                              </div>
                            </div>
                          </ng-container>
                        </div>
                        <div mwc-col [mwcSpan]="12">
                          <div class="mwc-text-sm-regular mwc-color-gray-500 mb-1">Intent:</div>
                          <div><span class="mwc-text-sm-medium">{{targetAudienceDetails.thingTargetAudience.thingJson.intent}}</span></div>
                        </div>
                        <div mwc-col [mwcSpan]="12">
                          <div class="mwc-text-sm-regular mwc-color-gray-500 mb-1">Industry:</div>
                          <ng-container>
                            <div class="view-layout">
                              <div *ngFor="let industry of targetAudienceDetails.thingTargetAudience.thingJson.industry;let last = last; let first = first;">
                                <span class="mwc-text-sm-medium">{{industry}}</span> <span *ngIf="!last" class="mx-1">|</span>
                              </div>
                            </div>
                          </ng-container>
                        </div>
                        <div mwc-col [mwcSpan]="12">
                          <div class="mwc-text-sm-regular mwc-color-gray-500 mb-1">Interests:</div>
                          <div style="display: flex;gap:16px;align-items: center;">
                            <ng-container>
                              <div class="view-layout">
                                <div *ngFor="let interests of targetAudienceDetails.thingTargetAudience.thingJson.interests;let last = last; let first = first;">
                                  <span class="mwc-text-sm-medium">{{interests}}</span> <span *ngIf="!last" class="mx-1">|</span>
                                </div>
                              </div>
                            </ng-container>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
          </div>
          
          <!-- Language Check -->
          <div *ngSwitchCase="5">
            <div class="mwc-text-lg-medium mb-3">Language</div>

            <mwc-form-item>
              <mwc-form-control [mwcSpan]="24">
                <div>
                  <mwc-select class="select-language" mwcSize="small" mwcDropdownClassName="select-language-dropdown"
                              [mwcShowArrow]="true" [(ngModel)]="selectedValueLanguage" [ngModelOptions]="{standalone: true}"
                              mwcPlaceHolder="Select language" [mwcCustomTemplate]="defaultTemplate"
                              class="mwc-xs-select mwc-text-sm-medium select-language" [mwcOptionHeightPx]="36"
                              (ngModelChange)='languageChanged($event)'>
                    <mwc-option *ngFor="let item of provinceData" mwcCustomContent [mwcLabel]="item.label" [mwcValue]="item.value">
                      {{item.label}} <span mwc-icon [mwcIconfont]="item.value"></span>
                    </mwc-option>
                  </mwc-select>
                  <ng-template #defaultTemplate let-selected>
                    <span mwc-icon [mwcIconfont]="selected.mwcValue"></span>
                    {{ selected.mwcLabel }}
                  </ng-template>
                </div>
              </mwc-form-control>
            </mwc-form-item>

            <!-- <div class="mt-4">
    <p class="mwc-text-sm-regular mwc-color-gray-700">
      Choosing the right language ensures your content resonates with your target audience.
    </p>
  </div> -->
          </div>
          
          <!-- Content Instructions -->
          <div *ngSwitchCase="6">
            <div class="mwc-text-lg-medium mwc-color-gray-700" style="margin-bottom: 20px;">Content Instructions</div>

            <div class="quick-upload-container" style="width: 100%;">
              <div class="quick-upload-header">
                <div class="quick-upload-info">
                  <div class="mwc-text-sm-medium mwc-color-gray-700">Quick Upload</div>
                  <div class="mwc-text-xs-regular mwc-color-gray-700">You can upload a maximum of 3 documents that you want referenced for content generation.</div>
                </div>
                <!-- Add Document Button - only visible when at least one doc is uploaded, and disabled when max documents reached -->
                <button mwc-button mwcType="link-color" mwcSize="small" (click)="onAddDocument()" id="addDocumentButton"
                      *ngIf="uploadedFiles.length > 0" [disabled]="uploadedFiles.length >= maxDocuments">
                  <span mwc-icon mwcIconfont="plus" style="font-size: 16px;"></span>
                  Add Document ({{uploadedFiles.length}}/{{maxDocuments}})
                </button>
              </div>

              <!-- Upload initial state - only shown when no files are being uploaded -->
              <div class="upload-area" *ngIf="uploadedFiles.length === 0" style="width: 100%;">
                <div class="upload-placeholder">
                  <div class="mwc-icon-highlight-primary-lg">
                  <span mwc-icon mwcIconfont="upload-cloud-02" style="font-size: 20px; color: #667085;"></span>
                  </div>
                  <button mwc-button mwcType="link-color" mwcSize="small" class="mt-2" id="browseFilesButton" (click)="onAddDocument()">Click to upload</button>
                  <div class="mwc-text-xs-regular mwc-color-gray-600 mt-1">Upload file size: 10KB to 5 MB</div>
                  <div class="mwc-text-xs-regular mwc-color-gray-600 mt-2">Accepted file type: DOC, DOCX & PDF</div>
                  <input 
                    type="file" 
                    #fileInput
                    id="document-file-input"
                    accept=".doc,.docx,.pdf,.txt"
                    style="display: none; position: absolute;"
                    (change)="onFileSelected($event)"
                  />
                </div>
              </div>

              <!-- File upload controls - only shown when there are files -->
              <div *ngIf="uploadedFiles.length > 0" class="uploaded-files-section" style="width: 100%;">
                <!-- Uploaded Files List with scrolling -->
                <div class="uploaded-files-list" style="width: 100%;">
                  <mwc-card *ngFor="let file of uploadedFiles" class="file-upload-card" style="width: 100%;">
                    <div class="file-upload-content">
                      <div class="file-info-section">
                        <div class="file-icon-wrapper">
                          <div class="mwc-icon-highlight-primary-md">
                            <span mwc-icon mwcIconfont="file-04" style="font-size: 16px; color: #155EEF;"></span>
                          </div>
                        </div>
                        <div class="file-details">
                          <div class="file-main-info">
                            <div class="file-name mwc-text-sm-medium mwc-color-gray-700">{{file.name}}</div>
                            <div class="file-size mwc-text-sm-regular mwc-color-gray-600">{{file.size}}</div>
                          </div>
                          <div class="progress-section">
                            <div class="progress-bar-container">
                              <mwc-progress [mwcPercent]="file.progress" mwcSize="small" [mwcShowInfo]="true" [mwcFormat]="percentFormat"></mwc-progress>
                            </div>
                          </div>
                          <div class="divider-line"></div>
                          <div class="document-type-section">
                            <div class="mwc-text-sm-medium mwc-color-gray-700" style="margin-bottom: 6px;">Document Type</div>
                              <mwc-select
                              mwcSize="small"
                              mwcPlaceholder="Enter"
                              [(ngModel)]="file.documentType"
                              [ngModelOptions]="{standalone: true}"
                              (ngModelChange)="onDocumentTypeChange(file.id, $event)"
                              [mwcDropdownClassName]="'mwc-xs-select-dropdown'" class="select-layout mwc-xs-select mwc-xxs-select mwc-text-sm-medium document-type-select" [mwcOptionHeightPx]="36">
                              <mwc-option *ngFor="let option of documentTypeOptions" [mwcLabel]="option.label" [mwcValue]="option.value">
                                {{ option.label }}
                              </mwc-option>
                            </mwc-select>
                          </div>
                          <div class="mt-2 w-100" *ngIf="file.documentType === 'other'">
                            <div class="mwc-text-sm-medium mwc-color-gray-700" style="margin-bottom: 6px;">Document Name</div>
                            <input mwc-input mwcSize="small" [(ngModel)]="file.documentDescription" [ngModelOptions]="{standalone: true}" placeholder="Enter document name" class="mwc-text-sm-regular" mwcSize="small"/>
                          </div>
                        </div>
                      </div>
                      <div class="remove-file-button">
                        <button mwc-button mwcType="link" mwcSize="small" (click)="removeUploadedFile(file.id)">
                          <span mwc-icon mwcIconfont="trash-01" style="font-size: 20px; color: #F04438;"></span>
                        </button>
                      </div>
                    </div>
                  </mwc-card>
                </div>
              </div>
            </div>

          </div>
        </div>
      </form>
    </div>
  </div>
  
  <!-- Navigation Buttons moved below template-container -->
  <div class="workflow-navigation">
    <!-- Left side - permanent Change Workflow button -->
    <div class="left-button">
      <button mwc-button mwcType="link-color" (click)="onChangeWorkflow()" [disabled]="isAnalyzing">
        <span mwc-icon [mwcIconfont]="'arrow-left'"></span>
        Change Workflow
      </button>
    </div>
    
    <!-- Right side - dynamic buttons based on tab -->
    <div class="right-buttons">
      <!-- Cancel button always present -->
      <!-- <button mwc-button mwcType="default" (click)="onCancel()">Cancel</button> -->
      
      <!-- Tab-specific action buttons -->
      <ng-container [ngSwitch]="selectedIndex">
        <ng-container *ngSwitchCase="0">
          <button mwc-button mwcType="primary" mwcSize="small" (click)="onNext()" [disabled]="isAnalyzing" [mwcLoading]="isAnalyzing">
           Next</button>
        </ng-container>
        <ng-container *ngSwitchCase="1">
          <button mwc-button mwcType="default" (click)="selectedIndex = 0" [disabled]="isAnalyzing">Back</button>
          <button mwc-button mwcType="primary" (click)="proceedFromKeywords()" [disabled]="isAnalyzing" [mwcLoading]="isAnalyzing"><span mwc-icon mwcIconfont="stars-02"></span>Analyse and proceed</button>
        </ng-container>
        <ng-container *ngSwitchCase="2">
          <button mwc-button mwcType="default-color" (click)="uploadInstructions()">
            Upload Instructions
          </button>
          <button mwc-button mwcType="default" (click)="selectedIndex = 1">Back</button>
          <button mwc-button mwcType="primary" (click)="onNext()">Proceed</button>
        </ng-container>
        <ng-container *ngSwitchCase="3">
          <button mwc-button mwcType="default" (click)="selectedIndex = 2">Back</button>
          <button mwc-button mwcType="primary" (click)="onNext()">Proceed</button>
        </ng-container>
        <ng-container *ngSwitchCase="4">
          <button mwc-button mwcType="default" (click)="selectedIndex = 3">Back</button>
          <button mwc-button mwcType="primary" (click)="onNext()">Proceed</button>
        </ng-container>
        <ng-container *ngSwitchCase="5">
          <button mwc-button mwcType="default" (click)="selectedIndex = 4">Back</button>
          <button mwc-button mwcType="primary" [mwcLoading]="isLoading" (click)="onSubmit()">
            <span mwc-icon mwcIconfont="stars-02" style="font-size: 16px;"></span>
            Generate
          </button>
        </ng-container>
        <ng-container *ngSwitchCase="6">
          <button mwc-button mwcType="default" (click)="selectedIndex = 2">Back</button>
          <button mwc-button mwcType="primary" (click)="proceedFromUploadInstructions()">Analyse and proceed</button>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #tableSpinTpl>
  <div style="display: flex; justify-content: center; align-items: center; width: 100%; min-height: 150px; height: 100%;">
    <img src="assets/images/ai-loader.gif" alt="Loading" style="width: 40px; height: 40px;">
  </div>
</ng-template>

